import Spinner from 'src/javascripts/components/utilities/Spinner';
import ScrollToTag from 'src/javascripts/components/nav/ScrollToTag';
import {filterTypeahead} from 'src/javascripts/components/typeaheads/TypeaheadBloodhounds';
import {genericDisplayTemplate, logoTemplate} from 'src/javascripts/components/typeaheads/TypeaheadTemplates';
import Swal from 'sweetalert2';
import ToastCustom from 'src/javascripts/components/alerts/ToastCustom';

// Must define Bloodhound explicitly here
// https://stackoverflow.com/questions/30750916/how-to-reference-typeahead-and-bloodhound-when-loading-npm-typeahead-js
const Bloodhound = require('src/javascripts/vendor/bloodhound');


export default class QuestionnairesCollectionResponsesDashboard {

  constructor() {}

  render() {

	  // Set account id
	  const accountUrl = $('body').attr('data-account-url');

	  // Questionnaires and portfolio items search
    filterTypeahead('#users_search', 'users', '/' + accountUrl + '/users/search?', 282, 'generic');
    filterTypeahead('#responsible_users_search', 'users', '/' + accountUrl + '/users/search?', 282, 'generic');

    // Auto-focus on expanding dropdown
    $('.dropdown-toggle').on('click', function() {
      let tp = $(this).closest('.btn-group').find('.typeahead');
      setTimeout(function() { tp.focus() }, 300)
    });

    // Select all responses
    $('.select-all-responses').click(function() {
      $('#questionnaire_responses_table tr .checkbox').prop('checked', this.checked);
    });

    // Export bulk report PDFs
    $('#bulkApproveResponses').click(function() {

      return Swal.fire({
        title: "Are you sure?",
        text: "Are you sure you want to approve all of the selected records?",
        animation: false,
        focusConfirm: false,
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'Cancel',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-primary-light',
          popup: 'animated fadeIn faster'
        },

        preConfirm: () => {

          // Set spinner and opacity to indicate working
          $('#questionnaire_responses_table').closest('.card-body').css('opacity', 0.2);
          Spinner($('#questionnaire_responses_table').closest('.card'));

          // Set params
          let accountUrl = $('body').attr('data-account-url');
          let url = '/' + accountUrl + '/data-collection/bulk_approve_requests?';
          let params = {};
          let recordIds = []
          $('#questionnaire_responses_table input.checkbox:checked').each(function() {
            let r = $(this).closest('tr').attr('data-record-id');
            if (typeof r !== 'undefined') {recordIds.push(r);}
          })
          params['response_ids'] = recordIds;

          // Send ajax call
          $.ajax({
            type: 'POST',
            dataType: 'application/json',
            url: url + $.param(params),
            complete: function() {
              ToastCustom('Success', 'Successfully approved the selected records', 5000);
              $('#questionnaire_responses_table').DataTable().ajax.reload();
            }
          });

        },
        
        allowOutsideClick: () => !Swal.isLoading()

      })

    })

    // Reload with attrs
    let reloadWithSelectedParams = function() {
	    let url = '/' + accountUrl + '/data-collection/dashboard';
      let params = {};
      params['responsible_users'] = $('#questionnaire_responses_table').attr('data-responsible-users');
      params['status'] = $('#questionnaire_responses_table').attr('data-status');
      let userId = $('#questionnaire_responses_table').attr('data-user-id');
      if (typeof userId === 'undefined') {
        params['questionnaire_user_id'] = 'all';
      } else {
        params['questionnaire_user_id'] = userId;
      }
      Turbo.visit(url + '?' + $.param(params));
    }

    // On selecting a responsible user
    $('#responsible_users_search').bind('typeahead:select typeahead:autocomplete', function(ev, suggestion) {
      $('#questionnaire_responses_table').attr('data-responsible-users', suggestion.name);
      reloadWithSelectedParams();
    })

    // On selecting a user
    $('#users_search').bind('typeahead:select typeahead:autocomplete', function(ev, suggestion) {
      let existingUserIds = $('#questionnaire_responses_table').attr('data-user-id');
      let uids = suggestion.value;
      if (typeof existingUserIds !== 'undefined') {uids = uids + ',' + existingUserIds;}
    	$('#questionnaire_responses_table').attr('data-user-id', uids);
    	reloadWithSelectedParams();
    })

  }

}